import Paper from '@mui/material/Paper'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import Divider from '@mui/material/Divider'
import Tooltip from '@mui/material/Tooltip'
import { MatchingFilter } from 'filterTypes'
import { useEvidenceFilterContext } from 'context/EvidenceFilterContext'
import { BaseSyntheticEvent } from 'react'
import { ResearchTypeMap } from 'pages/evidence/evidence.enums'
import { useFilterBarStyles } from '../FilterBar.styles'
import Popover from '../../popover/Popover'

interface EvidenceFiltersProps {}

const exactMatchesFilterOptions: Array<MatchingFilter> = [
    'MATCH_PROFILE',
    'MATCH_TUMOR'
]

export const EvidenceFilters = ({}: EvidenceFiltersProps) => {
    const { t } = useTranslation('filter')
    const styles = useFilterBarStyles()

    const {
        exactMatchers,
        handleExactMatcherFilterChange,
        selectedResearchType,
        setSelectedResearchType
    } = useEvidenceFilterContext()

    const handleRadioClick = (e: BaseSyntheticEvent) => {
        const { value } = e.target
        setSelectedResearchType(value === selectedResearchType ? '' : value)
    }

    return (
        <Popover
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            buttonComponent={
                <Button
                    color="primary"                                                                                                                                                                                                                     
                    variant="contained"
                    className={styles.addFilterEvidence}
                    sx={{ textTransform: 'none' }}  
                >
                    {t('filter.addFilterEvidence')}
                </Button>
            }
        >
            <Paper className={styles.popoverContentContainer}>
                <div className={styles.selectFilterContainer}>
                    <RadioGroup value={selectedResearchType}>
                        {Object.keys(ResearchTypeMap).map((type) => (
                            <Tooltip
                                key={type}
                                title={t(`filterTooltip.${type}`)}
                                classes={{ tooltip: styles.tooltip }}
                                placement="right"
                                arrow
                            >
                                <FormControlLabel
                                    value={type}
                                    control={
                                        <Radio onClick={handleRadioClick} />
                                    }
                                    label={t(`filter.${type}`)}
                                    className={styles.option}
                                />
                            </Tooltip>
                        ))}
                    </RadioGroup>

                    <Divider />

                    {exactMatchesFilterOptions.map((type) => (
                        <Tooltip
                            key={type}
                            title={t(`filterTooltip.${type}`)}
                            classes={{ tooltip: styles.tooltip }}
                            placement="right"
                            arrow
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={exactMatchers.includes(type)}
                                        onChange={() =>
                                            handleExactMatcherFilterChange(type)
                                        }
                                    />
                                }
                                label={t(`filter.${type}`)}
                                className={styles.option}
                            />
                        </Tooltip>
                    ))}
                </div>
            </Paper>
        </Popover>
    )
}

export default EvidenceFilters
